import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const addToLocalBasket = createAction('basketActions/addToLocalBasket');
export const removeFromLocalBasket = createAction('basketActions/removeFromLocalBasket');
export const addToUserBasket = createAsyncThunk('basketActions/addToUserBasket', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.addToUserBasket(payload);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
export const removeFromUserBasket = createAsyncThunk('basketActions/removeFromUserBasket', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.removeFromUserBasket(payload);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
